export const INIT_HOTEL_RESERVATIONS = "INIT_HOTEL_RESERVATIONS";
export const INIT_HOTEL_RESERVATION = "INIT_HOTEL_RESERVATION";
export const FETCH_HOTEL_RESERVATION_REQUEST =
  "FETCH_HOTEL_RESERVATION_REQUEST";
export const FETCH_HOTEL_RESERVATION_FAILURE =
  "FETCH_HOTEL_RESERVATION_FAILURE";
export const FETCH_HOTEL_RESERVATION_SUCCESS =
  "FETCH_HOTEL_RESERVATION_SUCCESS";
